module.exports = __webpack_public_path__ + "img/m-nex25-front.224bade4.jpg";